/*
 * @providesModule LeagueFTUEController
 */

class LeagueFTUEController {
  setHasSeenLeagueFTUE(hasSeen: boolean) {
    console.log('setHasSeenLeagueFTUE MOCK USED');
  }

  getHasSeenGlobalLeaguesMS1FTUE(): boolean {
    console.log('Not Implemented');
    return true;
  }

  getHasSeenProgressiveLeagueFTUE() {
    console.log('Not Implemented');
    return true;
  }

  setHasSeenGlobalLeaguesMS1FTUE(hasSeen: boolean) {
    console.log('Not Implemented');
  }

  setHasSeenProgressiveLeagueFTUE(hasSeen: boolean) {
    console.log('Not Implemented');
  }

  getHasSeenProgressiveLeagueV2FTUE(): boolean {
    console.log('Not Implemented');
    return true;
  }

  setHasSeenProgressiveLeagueV2FTUE(hasSeen: boolean) {
    console.log('Not Implemented');
  }

  getHasSeenAppropriateProgressiveLeagueFTUEByVersion(): boolean {
    console.log('Not Implemented');
    return true;
  }

  getHasSeenProgressiveLeagueV2MilestoneFTUE(): boolean {
    console.log('Not Implemented');
    return true;
  }

  setHasSeenProgressiveLeagueV2MilestoneFTUE(hasSeen: boolean) {
    console.log('Not Implemented');
  }
}

const SharedInstance = new LeagueFTUEController();
export {SharedInstance as default};
